import { TextCapitalized, Spacer, SidePanelDS } from "@qivia/ui";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { typographies } from "@qivia/ui/src/styles/figmaTypographies";
import { colors } from "@qivia/ui/src/styles/figmaColors";
import { PublicEmspCdrs } from "../../transactionsAPI";

const transactionInformations = [
  "locationName",
  "locationType",
  "locationAddress",
  "locationCity",
  "locationPostalCode",
];

export const CdrDetails = (props: { cdr: PublicEmspCdrs }) => {
  const { t } = useTranslation();

  const findKeysToTranslate = useCallback(
    (key: keyof PublicEmspCdrs, value: string) => {
      switch (key) {
        case "locationType":
          return t(`emspCdrs.locationType.${value}`);
        default:
          return value;
      }
    },
    [t],
  );

  return (
    <>
      <TextCapitalized>
        <StyledLabel>{t(`emspCdrs.informations.label.title`)}</StyledLabel>
      </TextCapitalized>
      {transactionInformations.map((informationLabel) => {
        const informationDisplay =
          props.cdr[informationLabel as keyof PublicEmspCdrs];

        const informationDisplayTranslated = findKeysToTranslate(
          informationLabel as keyof PublicEmspCdrs,
          informationDisplay as string,
        );

        return (
          <div key={informationLabel}>
            <Spacer y={2} />
            <SidePanelDS.SectionRow
              label={
                <StyledInformations key={informationLabel}>
                  <TextCapitalized>
                    {t(`emspCdrs.informations.label.${informationLabel}`)}
                  </TextCapitalized>
                </StyledInformations>
              }
              value={
                <TextCapitalized>
                  <StyledInformations key={informationLabel}>
                    {!informationDisplay ||
                    informationDisplay.toString() === "0" ? (
                      "-"
                    ) : (
                      <TextCapitalized>
                        {informationDisplayTranslated}
                      </TextCapitalized>
                    )}
                  </StyledInformations>
                </TextCapitalized>
              }
            />
          </div>
        );
      })}
    </>
  );
};

const StyledLabel = styled.div`
  ${typographies["Body/L"]}
  color: ${colors["colors/text/darkGrey"]};
`;

const StyledInformations = styled.div`
  display: flex;
  align-items: center;
  ${typographies["Body/L"]};
  color: ${colors["colors/text/black"]};
`;
